import { render, staticRenderFns } from "./SpareParts.vue?vue&type=template&id=11246efc&scoped=true"
import script from "./SpareParts.vue?vue&type=script&lang=js"
export * from "./SpareParts.vue?vue&type=script&lang=js"
import style0 from "./SpareParts.vue?vue&type=style&index=0&id=11246efc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11246efc",
  null
  
)

export default component.exports